const configService = {
  apiUrl: 'https://apitrinitas.concentricotests.com/api'
  // apiUrl: 'https://trinitas.test/api'
}

export default configService



// WEBPACK FOOTER //
// ./src/services/api-config.js